export default __webpack_public_path__ + "static/media/before02.9b239bad.svg";